import { Box } from '@mui/material';
import { SCUIContent } from '../../atomic/organisms';
import { JsonTemplateProvider } from './context/JsonTemplateContext';
import { JsonTemplateLayout } from './components/JsonTemplateLayout';
import { DJB } from './dynamicJsonBuilder.classes';
import './JsonTemplate.scss';

function JsonTemplate() {
    return (
        <SCUIContent>
            <Box className={DJB.page}>
                <JsonTemplateProvider>
                    <JsonTemplateLayout />
                </JsonTemplateProvider>
            </Box>
        </SCUIContent>
    );
}

export default JsonTemplate;
